var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "pui-lightbox",
    {
      key: _vm.refreshKey,
      staticClass: "help-case-upload-dialog",
      attrs: {
        "fit-content": true,
        visible: _vm.open,
        "default-header-label": _vm.$t("uploadDialog.title"),
        "default-trigger-label": "open"
      },
      on: { "puilightbox:close": _vm.close }
    },
    [
      _c("div", {
        attrs: { slot: "lightbox-trigger" },
        slot: "lightbox-trigger"
      }),
      _c("pui-form-select", {
        staticClass: "help-case-upload-dialog-select mt-6",
        attrs: { label: "", options: _vm.uploadFormSelectOptions },
        model: {
          value: _vm.selectedUploadForm,
          callback: function($$v) {
            _vm.selectedUploadForm = $$v
          },
          expression: "selectedUploadForm"
        }
      }),
      _vm.selectedUploadForm === "helpCaseData"
        ? _c(
            "div",
            { staticClass: "help-case-upload-dialog-content" },
            [_c("upload-help-case-list-dialog", { on: { close: _vm.close } })],
            1
          )
        : _c(
            "div",
            { staticClass: "help-case-upload-dialog-content" },
            [_c("upload-backfill-data-dialog", { on: { close: _vm.close } })],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }